class CartItems extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.content = this.querySelector('[data-cart-page-content]');

    this.addEventListener('click', (e) => {
      const removeLink = e.target.closest('[data-cart-remove]');
      if (removeLink) {
        e.preventDefault();
        this._changeLine(removeLink.dataset.key, 0, removeLink.closest('.cart-line-item'));
      }
    });

    // Quick-Add auf einer Cross-Sell-Produktkarte innerhalb der Warenkorbseite
    // fügt einen neuen Artikel hinzu (nicht nur eine Mengenänderung) — die
    // Zeilenliste muss danach ebenfalls neu geladen werden.
    this._onAdded = () => {
      if (this.sectionId) this._refresh();
    };
    document.addEventListener('cart:added', this._onAdded);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:added', this._onAdded);
  }

  async _changeLine(key, quantity, lineEl) {
    if (lineEl) lineEl.classList.add('is-updating');
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      const data = await response.json();
      if (!response.ok) {
        if (lineEl) lineEl.classList.remove('is-updating');
        window.ShirtWerk.announce('CartStatus', data.description || window.ShirtWerkStrings.error);
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: data.item_count } }));
      if (this.sectionId) await this._refresh();
    } catch (err) {
      if (lineEl) lineEl.classList.remove('is-updating');
    }
  }

  async _refresh() {
    const sections = await window.ShirtWerk.fetchSections([this.sectionId]);
    const html = sections[this.sectionId];
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-page-content]');
    if (fresh && this.content) {
      this.content.innerHTML = fresh.innerHTML;
      window.ShirtWerk.announce('CartStatus', window.ShirtWerkStrings.cartUpdated);
    }
  }
}
customElements.define('cart-items', CartItems);
